import type { ComponentType } from "react";

import TagBadgeUntyped from "src/components/Badge/TagBadge";

/** Typed surface for TagBadge (still implemented in JS with PropTypes). */
export type TagsEditorTagBadgeProps = {
  value: unknown;
  getTypeName?: () => string;
  withType?: boolean;
  selected?: boolean;
  disabled?: boolean;
  isRemoved?: boolean;
  highlighted?: boolean;
  tagTypeConfig?: unknown;
  onSelect?: (e: { stopPropagation: () => void }) => void;
  showEdit?: boolean;
  showRemove?: boolean;
  onEdit?: (e: { stopPropagation: () => void }) => void;
  onRemove?: (e: { stopPropagation: () => void }) => void;
  showUpdating?: unknown;
  showInfo?: boolean;
  onInfo?: (e: unknown) => void;
  role?: string;
  mr?: string;
  mt?: string;
  "data-testid"?: string;
  small?: boolean;
  withAppliedCount?: boolean;
};

export const TagsEditorTagBadge =
  TagBadgeUntyped as ComponentType<TagsEditorTagBadgeProps>;
